import { Link } from 'react-router-dom';
import { familias } from '@/mocks/curadoria';

interface FamiliaGridProps {
  /** Limita a quantidade de famílias exibidas (grid compacto). */
  limite?: number;
  /** Oculta o cabeçalho interno do bloco. */
  semCabecalho?: boolean;
  titulo?: string;
  descricao?: string;
}

export default function FamiliaGrid({
  limite,
  semCabecalho = false,
  titulo = 'Catálogo visual por categoria',
  descricao = 'Doze famílias comerciais reunidas em um único repertório, com fabricante, linha e aplicação identificados.',
}: FamiliaGridProps) {
  const lista = typeof limite === 'number' ? familias.slice(0, limite) : familias;

  return (
    <section aria-labelledby="catalogo-visual-titulo">
      <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
        {!semCabecalho && (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-14 items-end mb-10 md:mb-14">
            <div className="lg:col-span-7">
              <p className="hop-eyebrow text-foreground-400">Curadoria 2026</p>
              <h2
                id="catalogo-visual-titulo"
                className="mt-4 text-[28px] sm:text-[34px] md:text-[42px] leading-[1.06] tracking-[-0.036em] font-semibold text-foreground-950"
              >
                {titulo}
              </h2>
            </div>
            <div className="lg:col-span-5">
              <p className="text-[14px] md:text-[15px] leading-[1.65] text-foreground-500 max-w-[420px]">
                {descricao}
              </p>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10 md:gap-x-8 md:gap-y-14">
          {lista.map((familia) => {
            const temFotoReal =
              Boolean(familia.imagem) && !familia.imagem.includes('/api/search-image');

            return (
            <Link
              key={familia.id}
              to={familia.path}
              className="group block cursor-pointer"
              aria-label={`${familia.nome} — ver produtos`}
            >
              {temFotoReal ? (
                <div className="w-full aspect-[4/3] overflow-hidden rounded-[14px] bg-background-100">
                  <img
                    src={familia.imagem}
                    alt={`${familia.nome} — mobiliário Home Office Premium`}
                    title={`${familia.nome} — mobiliário corporativo e coletivo`}
                    className="w-full h-full object-cover object-top transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
                  />
                </div>
              ) : (
                <div className="w-full aspect-[4/3] rounded-[14px] border border-background-200 bg-background-50 flex items-center justify-center p-6">
                  <span className="text-[10.5px] uppercase tracking-[0.18em] text-foreground-300 text-center leading-[1.9]">
                    {familia.fabricantes.join(' · ')}
                  </span>
                </div>
              )}

              <div className="mt-4 flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <h3 className="text-[16px] md:text-[17.5px] leading-snug font-medium tracking-[-0.022em] text-foreground-950">
                    {familia.nome}
                  </h3>
                  <p className="mt-1.5 text-[12.5px] md:text-[13px] leading-[1.6] text-foreground-500">
                    {familia.descricao}
                  </p>
                  <p className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] uppercase tracking-[0.12em] text-foreground-400">
                    {familia.fabricantes.map((fabricante) => (
                      <span key={fabricante}>{fabricante}</span>
                    ))}
                  </p>
                </div>
                <span className="mt-1 w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full border border-background-200 text-foreground-400 group-hover:border-foreground-950 group-hover:text-foreground-950 transition-colors">
                  <i className="ri-arrow-right-up-line text-[13px]"></i>
                </span>
              </div>
            </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}